import type { GateName } from 'shared/types/experiments'

// Fail-closed. Only :Recognized is an evaluation. Binary per environment.
export const ETICKETS_FLOW_GATE: GateName = 'etickets_personalisation'

export type ReadableGate = {
  value?: boolean
  details?: { reason?: string } | null
} | null

const evaluated = (gate: ReadableGate): boolean => Boolean(gate?.details?.reason?.endsWith(':Recognized'))

export const eticketsFlowFallback = (): boolean => false

export const eticketsFlowEnabled = (gate: ReadableGate): boolean =>
  evaluated(gate) ? Boolean(gate?.value) : eticketsFlowFallback()
